import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import BCXChevronSwitch from '@/components/molecules/BCXChevronSwitch.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ThreadRepliesExpansionPanel',
  props: {
  label: {
    type: String,
    default: ''
  }
},
  emits: ['open', 'close'],
  setup(__props, { emit }) {



const isOpen = ref(true);

const toggle = () => {
  isOpen.value = !isOpen.value;
};



watch(isOpen, (is) => {
  if (is) {
    emit('open');
  } else {
    emit('close');
  }
});

return { __sfc: true,isOpen, toggle, emit, BCXChevronSwitch }
}

})